export default __webpack_public_path__ + "static/media/Vise of the Anointed.e479ee8f.jpg";